// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import { PermissionAction, PermissionItem } from "../model/Permissions";
import { AccountType } from "../model/AccountType";
import PermissionHelper from "../helpers/PermissionHelper";

export default {
  /**
   * Vue Plugin initialization for permissions
   * @param {object} app - Vue app
   */
  install: (app: any) => {
    app.config.globalProperties.$permission = (
      item: PermissionItem,
      action: PermissionAction,
      userId: string | null = null
    ) => {
      action = action || PermissionAction.READ;

      return PermissionHelper.hasPermission({
        item: item,
        action: action,
        userId: userId,
      });
    };

    app.config.globalProperties.$accountPermission = (type: AccountType, action: PermissionAction) => {
      return PermissionHelper.hasAccountPermission(type, action);
    };
  },
};
